import { StringsType } from "./en"

export const pt: StringsType = {
  bubbleExpiration: {
    expiredTitle: "Premium gratuito expirou",
    expiredSubtitle:
      "Atualize para Premium para a melhor experiência do PhotoVault",
    expiredSubtitlePremium:
      "Atualize para Premium para uma ótima experiência do PhotoVault",
    expiredSubtitleUltimate:
      "Atualize para Ultimate para a melhor experiência do PhotoVault",
    trashRecovery: "Recuperação da lixeira",
    cloudVault: "Cloud Vault",
    spaceSaver: "Space Saver",
    noAds: "Sem anúncios",
    everyPremiumFeature: "Obtenha todos os\nrecursos Premium",
    everyUltimateFeature: "Obtenha todos os\n recursos Ultimate",
    unlockUltimateTools:
      "Desbloqueie todas as ferramentas de privacidade no aplicativo.",
    cloudVaultUltimate: "Cloud Vault - 1.000 GB",
    organizationPlus: "Organização+",
    organizationPlusDesc: "Criar subálbuns, encontrar duplicados e mais.",
    perMonth: "por mês",
    perYear: "por ano",
    justOnce: "apenas uma vez",
    lifetime: "Vitalício",
    threeMonths: "3 Meses",
    lifetimeTitle: "Plano Vitalício",
    lifetimeDescription:
      "O plano vitalício estará disponível em breve. Fique atento às atualizações!",
    lifetimeFeature1: "Pagamento único",
    lifetimeFeature2: "Acesso vitalício a todos os recursos",
    lifetimeFeature3: "Melhor valor para usuários de longo prazo",
    lifetimeCta: "Comprar Lifetime",
    lifetimeSheetDisclaimer: "Backup na nuvem (50GB) incluído por 5 anos.",
    lifetimeSheetDisclaimerDetailed:
      "5 anos de backup do Cloud Vault (50 GB) estão incluídos com seu plano vitalício. Depois, você será elegível para uma assinatura do Cloud Vault com desconto disponível apenas para membros vitalícios. Todos os recursos Premium sempre permanecerão disponíveis sem custo adicional.",
    lifetimeDisclaimerCloudStorage:
      "5 anos de backup do Cloud Vault (50 GB) estão incluídos com seu plano vitalício.",
    lifetimeDisclaimerAfterPeriod:
      "Depois de 5 anos, você será elegível para uma assinatura do Cloud Vault com desconto disponível apenas para membros vitalícios.",
    lifetimeDisclaimerPremiumFeatures:
      "Todos os recursos Premium sempre permanecerão disponíveis sem custo adicional.",
    monthly: "Mensal",
    yearly: "Anual",
    selectPlan: "Selecione um plano para continuar",
    unlockPrivacyTools: "Desbloqueie excelentes ferramentas de privacidade.",
    cloudVaultGB: "Cloud Vault - 50 GB",
    secureBackups: "Backups seguros que permanecem criptografados.",
    freeUpSpace: "Libere espaço em seu telefone.",
    recoverDeleted: "Recupere itens excluídos da lixeira.",
    fullExperience: "A experiência completa sem interrupções.",
    restorePurchases: "Restaurar compras",
    basicTitle: "Private Photo Vault Basic",
    free: "GRATUITO",
    basicDescription:
      "Basic é a versão gratuita do PhotoVault. Ainda protege suas fotos importantes atrás de uma tela PIN e oferece bons recursos de privacidade.",
    switchToBasic: "Mudar para Basic",
    termsOfService: "Termos de serviço",
    privacy: "Privacidade",
    switchToPremium: "Mudar para Premium",
    switchToUltimate: "Mudar para Ultimate",
    premiumExpiredTitle: "Premium expirou",
    ultimateExpiredTitle: "Ultimate expirou",
    renewSubtitle: "Renove para a melhor experiência do Private Photo Vault",
    selectPlanOrSwitchToPro:
      "Selecione um plano ou mude para Pro gratuitamente",
    selectPlanOrSwitchToBasic:
      "Selecione um plano ou mude para Basic gratuitamente",
    proTitle: "Private Photo Vault - Pro",
    purchased: "Comprado",
    proDescription:
      "Como você comprou anteriormente a versão Pro única, poderá continuar usando todos os recursos Pro pelos quais pagou.",
    switchToPro: "Mudar para Pro",
    subscribeFor: (price: string) => `Assinar por ${price}/ano`,
    subscribeForMonth: (price: string) => `Assinar por ${price}/mês`,
    billedPerYear: (price: string) => `cobrado ${price} por ano`,
    oneStepSubtitle:
      "Atualize para Premium para a melhor\nexperiência do Private Photo Vault",
    oneStepSubtitleUltimate:
      "Atualize para Ultimate para a melhor\nexperiência do Private Photo Vault",
    purchaseWithAppStore: "Comprar com App Store",
  },
  title: "Acesso ilimitado a todos os recursos",
  freeTrial: "Avaliação gratuita",
  startPlan: "Iniciar Plano",
  pricePerMonth: (price: any) => `${price}/mês`,
  pricePerYear: (price: any) => `cobrado como ${price}/ano`,
  freeTrialDescriptionYearly: (days: number, price: string) =>
    `${days} dias grátis, depois ${price}/ano. Cancele quando quiser`,
  freeTrialDescriptionMonthly: (days: number, price: string) =>
    `${days} dias grátis, depois ${price}/mês. Cancele quando quiser`,
  discount: (discount: number) => `${discount}% DE DESCONTO`,
  new: "novo",
  trashRecovery: "Recuperação de Itens da Lixeira",
  adFree: "Experiência Sem Anúncios",
  breakIn: "Relatório de Invasão: Foto e GPS",
  wireless: "Transferência de Fotos através de Rede Sem Fios",
  decoy: "Senha de chamariz",
  pattern: "Bloqueio por Padrão",
  appDisguise: "Disfarce do Aplicativo",
  comingSoon: "em breve",
  subscriptionTerms: "Termos da Assinatura:",
  terms:
    "O pagamentos será cobrado em sua conta do iTunes na confirmação de compra. A assinatura será automaticamente renovada, a não ser que a renovação automática seja desativada pelo menos 24 horas antes do fim do período vigente. A renovação será cobrada na conta dentro do período de 24 horas antes do fim do período vigente. Você poderá gerenciar sua assinatura e desativar a renovação automática nas Configurações da sua Conta após a compra.",
  privacy: "Privacidade",
  alreadyPurchased: "Já Comprou?",
  termsButton: "Termos",
  monthly: "MENSAL",
  yearly: "ANUALMENTE",
  popular: "POPULAR",
  save: (discount) => `ECONOMIZE ${discount}%`,
  anniversaryTitle: (discount) =>
    `Oferta de Aniversário - ECONOMIZE ${discount}%`,
  blackFridayTitle: (discount) => `Sexta-feira Negra - ECONOMIZE ${discount}%`,
  year: "ano",
  years: "anos",
  hour: "hora",
  hours: "horas",
  minute: "minuto",
  minutes: "minutos",
  second: "segundo",
  seconds: "segundos",
  promoSubtitle: (hours) =>
    `Apresse-se, esta promoção durará apenas ${hours} horas`,
  offerExpires: "Até o término da oferta",
  unlockDeal: "Desbloquear oferta",
  blackFridayPaywallTitle: "Oferta da Black Friday",
  anniversaryPaywallTitle: "Sua oferta de aniversário 🎉",
  blackFridayPaywallSubtitle:
    "Não perca esta oferta única da Black Friday! Obtenha grandes descontos em nossa assinatura anual.",
  anniversaryPaywallSubtitle: (years: number, discount: number) =>
    `Parabéns pelos ${years} anos conosco! Para celebrar, aqui está um desconto de ${discount}% no Premium. Obrigado por sua lealdade!`,
  blackFridayAnnualTitle: "Sua oferta da Black Friday 🎉",
  anniversaryAnnualTitle: "Sua oferta de aniversário 🎉",
  oneYear: "1 ano",
  oneMonth: "1 mês",
  lockedIn: "Este preço anual será bloqueado PARA SEMPRE",
  subtitleFixed: "Apressa-te, esta venda vai acabar em breve!",
  importTitle: "Comece seu cofre",
  importSubtitle: "É 100% privado!",
  importInfo: "Adicione fotos e vídeos que você quer manter ocultos e seguros.",
  importCTA: "Adicionar ao cofre",
  skip: "Pular",
  totalMonthsPrice: (price: string) => `12 meses • ${price}`,
  monthlyPrice: (price: string) => `${price} / mês`,
  oneTimeOffer: {
    title: "Sua oferta única",
    subTitle: "Uma vez que você fechar sua oferta única, ela se vai!",
    claim: "Reivindique sua oferta única",
  },
  returnOffer: {
    monthly: (price: string) => `tão baixo quanto ${price}/mês`,
    title: "Sua Oferta Exclusiva de Retorno",
    subTitle:
      "Reative sua associação hoje a uma taxa especial! Disponível por tempo limitado",
    discountTitle: "Desconto Especial",
    cta: "Reativar Agora",
    discountSubTitle: "Oferta por tempo limitado",
  },
  off: "DESCONTO",
  special: "ESPECIAL",
  yearlyPlan: "Plano Anual",
  monthlyPlan: "Plano Mensal",
  subscribe: "Inscrever-se",
  cancelAnytime: "Cancelar a qualquer momento",
  freeTrialPaywall: {
    title: "Como funciona seu teste gratuito",
    firstStep: {
      title: "Agora",
      subtitle:
        "Desbloqueie acesso ilimitado ao Private Photo Vault e nunca se preocupe com alguém vendo suas fotos privadas novamente",
    },
    secondStep: {
      title: "Hoje: Comece seu teste gratuito",
      subtitle:
        "Desbloqueie acesso total ao PhotoVault. Você não será cobrado hoje.",
    },
    thirdStep: {
      title: "Em 7 Dias",
      subtitle:
        "Você será cobrado neste dia. Cancele a qualquer momento antes, sem complicações.",
    },
    whatsIncluded: "Veja o que está incluído",
    viewAllPlans: "Ver todos os planos",
    startTrial: "Iniciar Teste Gratuito",
    footerTitle: (yearlyPrice: string, monthlyPrice: string) =>
      `7 dias GRATUITOS e depois ${yearlyPrice}/ano\n(${monthlyPrice} por mês)`,
    footerDisclaimer:
      "Cancele a qualquer momento antes do término do seu teste. Você será cobrado apenas após 7 dias",
    featureList: {
      title: "O que é o Private Photo Vault?",
      infoTitle: "100% Privado e Seguro",
      infoSubtitle: "Proteja seus dados e previna acesso não autorizado",
      subTitle: "Torne-se Premium e obtenha acesso a:",
    },
    comparePlans: {
      ultimateYearly: "Ultimate anual",
      monthly: "Mensal",
      yearly: "Anual",
      threeMonths: "3 meses",
      freeFor: (days: number) => `Grátis por ${days} dias`,
      monthlyPrice: (price: string) => `apenas ${price}/mês`,
      dailyPrice: (price: string) => `apenas ${price}/dia`,
      cta: "Continuar",
    },
  },
  comparePlans: {
    title: "Comparar Planos",
    compare: "Comparar",
    freeTitle: "Gratuito",
    basicTitle: "Básico",
    premiumTitle: "Premium",
    ultimateTitle: "Ultimate",
    unlockPremium: "Desbloquear Premium",
    unlockUltimate: "Desbloquear Ultimate",
    choose: "Escolha um plano",
  },
  features: {
    organizationPlus: "Organização+",
    securityPlus: "Segurança+",
    duplicateDetection: "Detecção de Duplicados",
    faceDownLock: "Bloqueio com a Tela para Baixo",
    customIcons: "Ícones Personalizados",
    encryptedStorage: "Armazenamento de Fotos Criptografado",
    unlimitedAlbums: "Álbuns Ilimitados",
    browser: "Navegador Web Seguro",
    camera: "Câmera Privada",
    subalbums: {
      title: "Subálbuns",
      description:
        "Crie múltiplos níveis de subálbuns para organizar seu conteúdo de forma eficiente.",
    },
    filteringAndSearching: {
      title: "Filtragem e Pesquisa",
      description:
        "Pesquise em seus álbuns e aplique filtros para encontrar tipos de conteúdo específicos.",
    },
    alphanumericPasscode: {
      title: "Senha Alfanumérica",
      description:
        "Melhore a segurança do seu aplicativo usando uma senha alfanumérica.",
    },
    dualLock: {
      title: "Exigir Senha + Face ID",
      description:
        "Para segurança extra, exija tanto a senha quanto o Face ID toda vez que você entrar no aplicativo.",
    },
    locationBasedLock: {
      title: "Bloqueio Baseado em Localização",
      description:
        "Permitir o desbloqueio do aplicativo apenas em locais GPS aprovados.",
    },
  },
  gotIt: "Entendi!",
  promo: {
    premiumSave: (percent: string) => `ECONOMIZE ${percent}% NO PREMIUM`,
    monthly: (price: string) => `Apenas ${price}/mês`,
    yearly: (price: string) => `${price}/ano`,
    limited: "TEMPO LIMITADO RESTANTE",
    claimOffer: "Aproveitar oferta",
    seconds: (count: number) => (count == 1 ? "SEGUNDO" : "SEGUNDOS"),
    minutes: (count: number) => (count == 1 ? "MINUTO" : "MINUTOS"),
    oneTimeOffer: "OFERTA ÚNICA",
    normalFee: "taxa normal",
    backTo: "voltar para",
    yearlyShort: (price: string) => `${price}/anual`,
  },
  premiumToUltimateBlackFriday: {
    title: "PROMOÇÃO DE BLACK FRIDAY",
    subTitle: "VÁ PARA ULTIMATE",
    cloud: {
      title: "1.000 GB de Armazenamento em Nuvem",
      description: "Armazenamento em nuvem seguro para mais de 500.000 fotos",
    },
    duplicateDetection: {
      description: "Localize e remova imagens duplicadas",
    },
    organizationPlus: {
      description: "Crie Subálbuns, filtre e pesquise suas fotos",
    },
    securityPlus: {
      description:
        "Segurança aprimorada com senha alfanumérica, bloqueio baseado em localização e mais",
    },
    timeRemaining: "TEMPO RESTANTE",
    saleBanner: "PROMOÇÃO MEGA LIMITADA",
    saleTitle: "Promoção de Black Friday 🎉",
    bannerTitle: (discount: number) =>
      `${discount}% de desconto na Black Friday`,
    bannerCTA: "Aproveitar Oferta",
    monthPrefix: "12 meses • ",
    perMonthPrice(price: string) {
      return `${price} / mês`
    },
    monthly: "Mensal",
    ultimateLaunch: {
      title: "ATUALIZE PARA Ultimate",
      saleTitle: "Promoção de Lançamento Ultimate 🚀",
      bannerTitle: (discount) => `Lançamento Ultimate - ECONOMIZE ${discount}%`,
    },
  },
  blackFridayNoFeatures: {
    title: "BLACK FRIDAY",
    lessThanCoffee: "Menos que um café.",
    dontWait: "Não espere! Esta oferta desaparecerá em breve",
    whatWaiting: "O que você está esperando?",
    claimOffer: "REIVINDIQUE SUA OFERTA ÚNICA",
    moneyBack: "Garantia de devolução do dinheiro",
  },
  cyberMonday: {
    title: "CYBER MONDAY",
    subTitle: "OBTENHA ULTIMATE",
    cloud: {
      title: "1.000 GB de Armazenamento em Nuvem",
      description: "Armazenamento em nuvem seguro para mais de 500.000 fotos",
    },
    duplicateDetection: {
      description: "Localize e remova imagens duplicadas",
    },
    organizationPlus: {
      description: "Crie subálbuns, filtre e pesquise suas fotos",
    },
    securityPlus: {
      description:
        "Segurança aprimorada com senha alfanumérica, bloqueio por localização e mais",
    },
    timeRemaining: "TEMPO RESTANTE",
    saleBanner: "OFERTA CYBER LIMITADA",
    saleTitle: "Oferta Cyber Monday",
    bannerTitle: (discount: number) =>
      `${discount}% de desconto na Cyber Monday`,
    bannerCTA: "Aproveitar Oferta",
    monthPrefix: "12 meses • ",
    perMonthPrice(price: string) {
      return `${price} / mês`
    },
    monthly: "Mensal",
    ultimateLaunch: {
      title: "ATUALIZE PARA Ultimate",
      saleTitle: "Promoção de Lançamento Ultimate",
      bannerTitle: (discount: number) =>
        `Atualize para Ultimate - ECONOMIZE ${discount}%`,
    },
  },
  beforeYouGo: {
    title: "Espere - Antes de você ir",
    subtitle: "Mantenha suas fotos seguras e privadas",
    subtitle2: "Ganhe 7 dias de Premium totalmente grátis.",
    cta: "Comece seu teste gratuito",
    cancelTitle:
      "Cancele a qualquer momento antes do término do seu teste, e você não será cobrado até que os 7 dias completos se passem.",
    skipCta: "Não, obrigado",
  },
  enableTrial: "Ainda não tem certeza? Ative o teste gratuito",
  startTrial: "Inicie o teste gratuito",
  trialActivated: (days) => `TESTE DE ${days} DIAS ATIVADO`,
  specialOffer: {
    enabledTitle: "Oferta especial ativada",
    trialTitle: "Resgate sua avaliação gratuita extra de 7 dias",
    expirationTitle: "Sua assinatura está prestes a expirar!",
    expirationSubtitle: "Renove sua assinatura por um preço especial!",
    priceBoxExpiration: {
      title: "Oferta especial de renovação",
      offerName: "Plano anual",
      ctaTitle: "Aproveitar oferta especial",
    },
    priceBoxTrial: {
      title: "Oferta exclusiva: avaliação gratuita extra de 7 dias",
      offerName: "Avaliação extra de 7 dias",
      ctaTitle: "Resgatar avaliação gratuita",
    },
  },
  premiumToUltimate: {
    titleLine1: "ATUALIZAÇÃO PARA ULTIMATE",
    titleLine2: "OFERTA ÚNICA",
    megaSaleBanner: "MEGA PROMOÇÃO POR TEMPO LIMITADO",
    upgradeTitle: "Oferta de Upgrade Ultimate",
    yearlySubtitlePrefix: "12 meses •",
    monthlyPriceSuffix: "/ mês",
  },
  monthlyToYearly: {
    titleLine1: "Upgrade para Plano Anual",
    titleLine2: "Oferta Única",
    subtitleWarning: "Uma vez fechado, o seu desconto único desaparece!",
    specialLabel: "ESPECIAL",
    offerTitle: "Aproveite a sua oferta única",
    offerName: "Plano Anual",
    subscribeButton: "Assinar",
    cancelAnytime: "Cancele a qualquer momento",
    yearlySubtitlePrefix: "12 meses •",
    monthlyPriceSuffix: "/ mês",
  },
  expiration: {
    warmup: {
      close: "FECHAR",
      subtitle:
        "Mantenha suas fotos SEGURAS e RECUPERÁVEIS caso perca seu celular ou ele seja roubado",
      features: {
        cloudVault: {
          title: "Cloud Vault",
          subtitle: "Backup criptografado dos seus arquivos",
        },
        cloudVaultUltimate: {
          title: "Cloud Vault",
          subtitle: "1.000 GB de armazenamento Cloud Vault",
        },
        reviews: {
          title: "Mais de 500.000 avaliações 5 estrelas",
          subtitle: "Confiado por milhões",
        },
        noAds: {
          title: "Sem anúncios",
          subtitle: "Experiência sem anúncios",
        },
        organizationPlus: {
          title: "Organization+",
          subtitle: "Subálbuns, filtros aprimorados e mais",
        },
      },
      footer: "& todos os recursos!",
      switchToPremium: "Mudar para Premium",
      switchToUltimate: "Mudar para Ultimate",
      titlePremium: "Seu Premium expirou!",
      titleUltimate: "Seu Ultimate expirou!",
      popular: "POPULAR",
      perMonth: "por mês",
      perYear: "por ano",
    },
    titlePremium: "Premium expirado",
    titleUltimate: "Ultimate expirado",
    subtitlePremium:
      "Renove o Premium para manter todos os recursos ou mude para o Basic gratuitamente",
    subtitleUltimate:
      "Renove o Ultimate para manter todos os recursos ou mude para o Basic gratuitamente",
    basicButton: "Mudar para Basic",
    basicTitle: "O que é o Basic?",
    basicDescription:
      "Basic é a versão gratuita do aplicativo. Você ainda pode proteger suas fotos e vídeos com um PIN, mas perderá acesso ao backup criptografado do Cloud Vault e a todos os outros recursos Premium",
  },
  animated: {
    title: "Escolha seu plano",
    yearlyPrice: (price: string) => `Apenas ${price} por ano`,
    subtitle: "Renovação automática. Cancele a qualquer momento",
    cta: "Continuar",
    trial: "Teste gratuito ativado",
    breakinShort: "Relatório de invasão",
    unlimitedPhotos: "Fotos ilimitadas",
  },
  choosePlanTitle: "Escolha Seu Plano",
  socialProof: {
    titleWithTrial: "Experimente Private Photo Vault\nGrátis por 7 Dias",
    title: "Experimente Private Photo Vault",
    continueForFree: "Continuar gratuitamente",
    continue: "Continuar",
    cancelAnytime: "Cancele a qualquer momento",
    mostPopular: "Mais popular",
    twelveMonths: "12 Meses",
    oneMonth: "1 Mês",
    yearlySubtitle: (monthlyPrice: string, yearlyPrice: string) =>
      `${monthlyPrice}/mês, cobrado como ${yearlyPrice}/ano`,
    monthlySubtitle: (price: string) => `${price}/mês`,
  },
  yearlyOnlyAppStore: {
    yearly: "Anual",
    billedYearly: (price: string) => `${price} cobrado anualmente`,
    perMonth: (price: string) => `${price}/mês`,
    startTrial: (days: number) => `Iniciar teste de ${days} dias`,
    purchaseWithAppStore: "Comprar com a App Store  (sem teste)",
    purchaseImmediately: "Comprar imediatamente  (sem teste)",
  },
  multistep: {
    lockTitle: "Bloqueie fotos privadas",
    subtitle: {
      line1: "Oferecemos",
      line2: "7 dias grátis",
      line3: "para que todos possam proteger suas fotos",
    },
    subtitleReminder: {
      line1: "Você receberá um lembrete ",
      line2: "2 dias ",
      line3: "antes do fim do teste.",
    },
    noPaymentNow: "Sem pagamento agora",
    startFreeWeek: "Comece sua semana GRÁTIS",
    payTitle: "7 dias gratuitos",
    afterPrice: (price: string) => `depois ${price} / mês`,
    afterBilling: (price: string) =>
      `(cobrado como ${price} anuais após o teste)`,
    footerTitle: (price) => `Grátis por 7 dias. Depois, ${price}/ano`,
    footerMonthlyTitle: (price) => `Você será cobrado ${price} imediatamente.`,
    headerTitle: "Teste gratuito de 7 dias",
    anual: "Anual",
    monthly: "Mensal",
    noTrial: "Sem teste gratuito",
    yearlyPrice: (price) => `${price} / Ano`,
  },
  oneTimeOfferTitle: "OFERTA ÚNICA",
  unlockPremiumFor: "Desbloqueie o Premium Anual por",
  oneTimeOfferSubtitle: "Esta é uma oferta única",
  lowestPrice: "O MENOR PREÇO DE SEMPRE",
  summerSale: {
    title: "SALDOS DE VERÃO",
    tagline: "O sol vê tudo... exceto o que está no seu cofre!",
    timeRemaining: "A oferta expira em breve",
    limitedTimeOffer: "Oferta por tempo limitado",
    savePercent: (percent: number) => `Poupe ${percent}%`,
    bannerSubtitle: (price: string) => `Obtenha Premium por ${price}`,
    bannerSubtitleUltimate: (price: string) => `Obtenha Ultimate por ${price}`,
    getPremium: "Obter privacidade Premium",
    getUltimate: "Obter privacidade Ultimate",
    hours: "horas",
    minutes: "minutos",
    seconds: "segundos",
    features: {
      premiumFeature: {
        title: "Obtenha todas as funcionalidades Premium",
        description: "Ferramentas Premium que protegem a sua privacidade.",
      },
      cloudVault: {
        title: "Cloud Vault - 50 GB",
        description: "Backups seguros que permanecem criptografados.",
      },
      noAds: {
        title: "Sem anúncios",
        description: "A experiência completa sem interrupções.",
      },
      faceDownLock: {
        title: "Bloqueio Face Down",
        description: "Bloqueie a app instantaneamente virando o telemóvel.",
      },
      breakInReports: {
        title: "Relatórios de invasão",
        description: "Alertas se alguém tentar aceder ao seu cofre.",
      },
    },
    pricing: {
      summerSale: "Saldos de verão",
      monthly: "Mensal",
      perMonth: (price: string) => `${price} / mês`,
      twelveMonths: "12 meses",
      originalPrice: (price: string) => price,
      discountedPrice: (price: string) => price,
    },
  },
  autumnSale: {
    title: "PROMOÇÃO DE OUTONO",
    tagline: "As folhas cobrem tudo…\nincluindo seus segredos!",
    buttonTitle: "Promoção de Outono",
  },
  halloweenSale: {
    title: "PROMOÇÃO DE HALLOWEEN",
    tagline: "A noite esconde muitas coisas…\nespecialmente as suas!",
    buttonTitle: "Promoção de Halloween",
  },
  winterSale: {
    title: "PROMOÇÃO DE INVERNO",
    tagline: "Vamos proteger suas fotos sob a neve",
    buttonTitle: "Promoção de Inverno",
  },
  springSale: {
    title: "PROMOÇÃO DE PRIMAVERA",
    tagline: "Atualize para o Premium com este desconto exclusivo de primavera",
    ultimateTagline:
      "Atualize para o Ultimate com este desconto exclusivo de primavera",
    buttonTitle: "Promoção de Primavera",
  },
  emailPromo: {
    title: "Oferta Premium Exclusiva",
    upgradeButton: "Atualizar para Premium",
    yearlyTitle: "Premium Anual",
    decoyDescription: "Criar um cofre falso que abre com uma senha isca",
  },
  tabsPaywall: {
    premiumTab: "Premium",
    ultimateTab: "Ultimate",
    premiumTitle: "Desbloqueie o Premium para",
    premiumTitleHighlight: "Proteger Seu Cofre",
    ultimateTitleStart: "Desbloqueie o ",
    ultimateTitleHighlight: "Ultimate",
    ultimateTitleEnd: " Para\nAcessar Todos os Recursos",
    perMonth: "/mês",
  },
  trialFooter: {
    freeTrialDays: (days: number) => `${days} dias\nde teste grátis`,
    noFreeTrial: "Sem teste\ngratuito",
    noCommitment: "Sem compromisso. Cancele a qualquer momento.",
    cta: "Experimentar grátis",
    ctaMonthly: "Continuar",
    yearly: "Anual",
    monthly: "Mensal",
  },
  onboardingUltimateAlternate: {
    title: "Comece seu teste gratuito",
    premiumDescription: "Desbloqueie excelentes ferramentas de privacidade.",
    ultimateDescription: "A melhor experiência do Photo Vault.",
    includesPremium: "Inclui Premium",
    trialPricing: (yearlyPrice: string, monthlyPrice: string) =>
      `7 dias grátis, depois ${yearlyPrice} (${monthlyPrice}/mês)`,
    timeline: {
      today: "Hoje:",
      todayDescription: "comece seu teste gratuito",
      day5: "Dia 5:",
      day5Description: "receba lembrete",
      day7: "Dia 7:",
      day7Description: (yearlyPrice: string) =>
        `você será cobrado ${yearlyPrice}`,
    },
    comparisonTable: {
      header: "O que você obtém",
    },
    didYouKnow: {
      label: "Você sabia?",
      statNumber: "3X",
      statDescription: "Assinantes obtêm 3 vezes mais tranquilidade",
    },
    pricing: {
      yearlyPlanTitle: "Plano anual",
      yearlyPlanSubtitle: (yearlyPrice: string) => `${yearlyPrice}/ano`,
      yearlyAmount: (monthlyPrice: string) => `${monthlyPrice}/mês`,
      monthlyTitle: "Mensal",
      monthlyAmount: (monthlyPrice: string) => `${monthlyPrice}/mês`,
      popularBadge: "POPULAR",
    },
    ctaButton: "Iniciar teste gratuito",
  },
  threeStepExpiration: {
    premiumExpired: "Seu Premium Expirou",
    ultimateExpired: "A Assinatura Ultimate Expirou",
    freeExpired: "O Premium Gratuito Expirou",
    subtitle: "Sua conta foi rebaixada.",
    subtitlePremium: "Sua conta foi rebaixada.",
    subtitleUltimate: "Sua conta foi rebaixada.",
    allPremiumFeatures: "Todos os Recursos Premium",
    allUltimateFeatures: "Todos os Recursos Ultimate",
    spaceSaver: "Economizador de Espaço",
    disabled: "Desativado",
    restoreMyProtection: "Restaurar Acesso Completo",
    seeWhatImLosing: "Ver o que estou perdendo",
    photosSafeWarning:
      "Suas fotos estão seguras, mas recursos críticos estão desativados.",
    continue: "Continuar",
    heresWhatYoureLosing: "Veja o que você está perdendo",
    allFeaturesDisabled:
      "Todos estes recursos premium serão desativados na sua conta:",
    allFeaturesDisabledUltimate:
      "Todos estes recursos ultimate serão desativados na sua conta:",
    back: "Voltar",
    stepOf: (current: number, total: number) => `Passo ${current} de ${total}`,
    restoreAllFeatures: "Restaurar Todos os Recursos",
    continueWithout: "Continuar (recursos permanecem desativados)",
    allPremiumDetail:
      "Você perderá o acesso a todos os recursos premium que mantêm suas fotos privadas seguras e organizadas.",
    cloudVaultDetail:
      "Seu backup na nuvem será excluído. Se seu dispositivo for perdido ou danificado, suas fotos privadas serão perdidas permanentemente.",
    cloudVaultDetailBold: "Seu backup na nuvem será excluído.",
    cloudVaultDetailRest:
      "Se seu dispositivo for perdido ou danificado, suas fotos privadas serão perdidas permanentemente.",
    spaceSaverDetail:
      "As fotos ocuparão todo o espaço de armazenamento no seu dispositivo. Você não poderá mais comprimir e otimizar seu cofre.",
    trashDetail:
      "Fotos excluídas acidentalmente não poderão ser recuperadas. Uma vez excluídas, serão perdidas permanentemente.",
    noAdsDetail:
      "Você começará a ver anúncios em todo o aplicativo. O Premium remove todos os anúncios para uma experiência sem interrupções.",
    decoyDetail:
      "Sua senha isca deixará de funcionar. Qualquer pessoa que a conheça poderá acessar seu cofre real.",
    chooseYourPlan: "Escolha Seu Plano",
    restoreFullProtection: "Restaurar proteção completa instantaneamente",
    restorePremiumInstantly: "Restaurar Premium instantaneamente",
    restoreUltimateInstantly: "Restaurar Ultimate instantaneamente",
    instantlyRestored: "Restaurado instantaneamente",
    reassurance:
      "Continue exatamente de onde parou — cada recurso será totalmente restaurado no momento em que você assinar.",
    subscribeAndRestore: "Assinar e Restaurar",
    scrollForMore: "Role para ver mais",
    bestValue: "MELHOR VALOR",
    switchToBasicDescription:
      "Você ainda poderá ver e acessar todas as suas fotos existentes no aplicativo. Seus álbuns e mídias permanecem seguros no seu dispositivo.",
    viewAndAccess: "ver e acessar todas as suas fotos existentes",
    premiumFeaturesDisabled: "",
    restorePremium: "Restaurar Premium",
    restoreUltimate: "Restaurar Ultimate",
    choosePlanToReactivate: "Escolha um plano para reativar todos os recursos",
    perMonth: "/mês",
    twelveMonths: "Anual",
    oneMonth: "1 Mês",
  },
  backupPaywall: {
    title: "Backups não ativados",
    subtitle:
      "Suas fotos e vídeos não estão salvos. Assine o Premium para ativar backups e desbloquear todos os recursos",
    subscribe: "Obter Premium",
    cancelAnytime: "Sem compromisso. Cancele a qualquer momento",
  },
  lossAversion: {
    title: "Nenhuma foto foi salva\nem backup.",
    subtitle:
      "Cada foto está armazenada apenas neste dispositivo. Perca-o e elas desaparecem para sempre.",
    photosUnprotected: "fotos\ndesprotegidas",
    backedUp: "em backup",
    daysAtRisk: "dias em risco",
    backupCoverage: "Cobertura de backup",
    vaultProtected: (percent: number) =>
      `${percent}% do seu cofre está protegido`,
    premiumTitle: "O que você ganha com o Premium",
  },
}
